import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';

export type Rating = 'unlikely' | 'at_risk' | 'slightly_at_risk' | 'on_track' | 'likely';

const RATING_ORDER: Rating[] = ['unlikely', 'at_risk', 'slightly_at_risk', 'on_track', 'likely'];

type Props = {
	rating: Rating;
};

const RatingScale = ({ rating }: Props) => {
	const { t } = useTranslation();
	const classes = new BemClass('OrderForecastRatingScale');
	const currentIndex = RATING_ORDER.indexOf(rating);

	return (
		<div className={classes.b()}>
			{RATING_ORDER.map((r, i) => {
				const isCurrent = i === currentIndex;
				const stepClass = classes
					.elem('step')
					.mod({
						current: isCurrent,
						passed: i < currentIndex
					})
					.b();
				return (
					<div key={r} className={stepClass} aria-current={isCurrent ? 'step' : undefined}>
						<span className={classes.elem('tick').b()} />
						<span className={classes.elem('label').b()}>{t(`ai.dealForecast.rating.short.${r}`)}</span>
					</div>
				);
			})}
		</div>
	);
};

export default RatingScale;
